import React, { Component } from 'react';

import {
  Panel,
  PanelUser,
  PanelAction,
  PanelActionWithLink,
  PanelActionWrapper,
  PanelList,
  PanelListItem,
  PanelListTitle,
  PanelListWrapper,
} from '../UI/Panel';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generalActions } from '../../actions/general.action';
import './example-panel.scss';

class ExamplePanel extends Component {
  constructor(props) {
    super(props);
  }
  async componentDidMount() {
    await this.props.generalActions.getServerVersion();
  }
  removeBodyClass = () => {
    document.body.classList.remove('content-side-open');
  };
  render() {
    const { name, surname, email } =
      JSON.parse(localStorage.getItem('userProfile')) || {};
    const { t } = this.props;
    return (
      <Panel style={{ width: '100%' }}>
        <PanelUser
          name={`${name} ${surname}`}
          subtitle={email}
          image="./img/tmp/user-8.jpg"
        />

        <PanelListWrapper>
          <p>
            {t('Server')} v{this.props.general.serverVersion}
          </p>
          <p>{t('Client')} v7.2023.06.01</p>
          {/* <PanelListTitle>Todays Tasks</PanelListTitle>

          <PanelList>
            <PanelListItem>Start alerts dashboard next week.</PanelListItem>
            <PanelListItem>Implement some more integration tests</PanelListItem>
          </PanelList>

          <PanelListTitle>
            <span style={{ color: 'red' }}>Critical Alerts</span>
          </PanelListTitle>

          <PanelList>
            <PanelListItem>
              Temperature for <a>Sensor #1</a> above threshold of 90 degrees
            </PanelListItem>
            <PanelListItem>
              Nuclear meltdown in progress on <a>Reactor #5</a>
            </PanelListItem>
          </PanelList> */}
        </PanelListWrapper>

        <PanelActionWrapper>
          <PanelActionWithLink
            destination="/my-profile"
            title={t('My Profile')}
            icon="person"
            onClick={this.removeBodyClass}
          />
          {/* <PanelActionWithLink
            destination="/create"
            title={t('Create')}
            icon="group_add"
            onClick={this.removeBodyClass}
          /> */}
          <PanelActionWithLink
            destination="/configure"
            title={t('Configure')}
            icon="build"
            onClick={this.removeBodyClass}
          />
        </PanelActionWrapper>
      </Panel>
    );
  }
}

function mapStateToProps(state) {
  return {
    general: state.general,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    generalActions: bindActionCreators(
      Object.assign({}, generalActions),
      dispatch,
    ),
  };
}

export default withTranslation('app')(
  connect(mapStateToProps, mapDispatchToProps)(ExamplePanel),
);
